import Link from 'next/link';
// Translation Higher Order Component
import { translate } from 'react-switch-lang';

//Basic Country Link Layout, that defines a route, and a title, and returns a JSX element of a Link with a Title
const BasicVaccineLink = (props) => {
	const { vaccine, what_is, can_be_vaccinated, protection, source, occurrence, kids, title, more, t } = props;

	const data = {
		vaccine: `vaccines.${vaccine}`,
		what_is: what_is,
		can_be_vaccinated: can_be_vaccinated,
		protection: protection,
		source: source,
		occurrence: occurrence,
		kids: kids,
		title: title
	};

	return (
		<Link
			passHref
			as={`/vaccines/${t(`${data.vaccine}.title`).toLowerCase()}`}
			href={{ pathname: '/vaccines/[id]', query: { data: JSON.stringify(data) } }}
		>
			<a
				className={
					more ? 'country_list clickable country_links style_italic' : 'page_subtext vaccines-header text-uppercase'
				}
			>
				{title}
			</a>
		</Link>
	);
};

export default translate(BasicVaccineLink);
